export enum Actions {
    SET_KYC_INVOKER = "SET_KYC_INVOKER",
    SET_KYC_COMPLETED = "SET_KYC_COMPLETED",
    SET_PRODUCT_CODE = "SET_PRODUCT_CODE",
    CLEAR_KYC_STATE = "CLEAR_KYC_STATE",
}

export const setKycInvoker = (invoker: string) => {
    return {type: Actions.SET_KYC_INVOKER, body: invoker};
};

export const kycCompleted = (completed: boolean) => {
    return {type: Actions.SET_KYC_COMPLETED, body: completed};
};

export const setProductCode = (product: string) => {
    return {type: Actions.SET_PRODUCT_CODE, body: product};
};

export const clearKycStates = () => {
    return {type: Actions.CLEAR_KYC_STATE};
};
